module.exports = __webpack_public_path__ + "components/discount-pages/db-journey/static/db-2560-e50c896b2ee1027f7a1c98ad50b33f14.jpg";